export const increase = (prev: number) => prev + 1
